import React, { useState } from "react";
import DashboardLayout from "../layouts/admin_layout";
import { useSelector } from "react-redux";
import UserOne from "../../assets/empty.jpg";
import InputField from "../../components/input_field";
import { Link } from "react-router-dom";
import axios from "axios";

export default function UserSettings() {
	return (
		<DashboardLayout>
			<div>Coming soon...</div>
		</DashboardLayout>
	);
}
